import React, { useState } from 'react';

// Types
import { User } from 'Shared/constants/types';

// Components
import { WpModal, WpModalHeader, WpModalBody } from 'Wpds/components/modal';
import { WpDataTableV2, SortDirections } from 'Wpds/components/table-v2';
// import WpIcon from 'Wpds/components/icon/WpIcon';
import WpTextField from 'Wpds/components/text-field/WpTextField';
import AttendeeDetailsListItem from './AttendeeDetailsListItem';

// Styles
import './AttendeeDetailsModal.scss';

type Props = {
  isOpen: boolean;
  toggleIsOpen: () => void;
  users: Array<User>;
};

const AttendeeDetailsModal = ({ isOpen, toggleIsOpen, users }: Props) => {
  const [textSearchInput, setTextSearchInput] = useState('');

  const userCount = users.length;

  const filteredUsers = users.filter(
    user =>
      user.fullName.toLocaleLowerCase().includes(textSearchInput.toLocaleLowerCase()) ||
      user.email.toLocaleLowerCase().includes(textSearchInput.toLocaleLowerCase())
  );

  const showEmptyState = filteredUsers.length === 0;
  const showOnClear = textSearchInput !== '';

  const columns = [
    {
      label: 'Name',
      selector: row => row.fullName,
      component: ({ row }) => <AttendeeDetailsListItem user={row} />,
      maxWidth: '25rem',
      sort: SortDirections.ASC,
    },
  ];

  const handleOnClear = () => {
    setTextSearchInput('');
  };

  const baseClassName = 'AttendeeDetailsModal';

  return (
    <WpModal isOpen={isOpen} onToggle={toggleIsOpen} size="sm">
      <WpModalHeader>{userCount > 1 ? <>{userCount} Attendees</> : <>{userCount} Attendee</>}</WpModalHeader>
      <WpModalBody>
        <div className={`${baseClassName}__toolbar`}>
          <div className={`${baseClassName}__toolbar__search`}>
            <WpTextField
              id="members-search-input"
              label="Search Attendees"
              placeholder="Search Attendees"
              labelHidden
              prefixIcon="search"
              value={textSearchInput}
              onChange={setTextSearchInput}
              onClear={showOnClear && handleOnClear}
            />
          </div>
        </div>
        {/* <div className={`${baseClassName}__add-bar`} role="button">
          <div className={`${baseClassName}__add-bar__icon`}>
            <WpIcon name="plus" />
          </div>
          <p className={`${baseClassName}__add-bar__label`}>Invite People</p>
        </div> */}
        {showEmptyState ? (
          <div className={`${baseClassName}__empty`}>
            <p className={`${baseClassName}__empty__title`}>No matches found</p>
          </div>
        ) : (
          <div className={`${baseClassName}__table`}>
            <WpDataTableV2
              tableId="membersTable"
              data={filteredUsers}
              columns={columns}
              showInContainer={false}
              showHeader={false}
            />
          </div>
        )}
      </WpModalBody>
    </WpModal>
  );
};

export default AttendeeDetailsModal;
